(() => {
  const header = document.querySelector('[data-ax-header]');
  if (!header || header.dataset.axReady === 'true') return;
  header.dataset.axReady = 'true';

  const drawer = header.querySelector('[data-ax-drawer]');
  const toggle = header.querySelector('[data-ax-toggle]');
  const closeButton = header.querySelector('[data-ax-close]');
  const count = header.querySelector('[data-ax-cart-count]');
  const cartLink = header.querySelector('[data-ax-cart]');
  let returnFocus = null;
  let lockedScrollY = 0;
  let scrollFrame = false;
  let previousY = window.scrollY;

  const refreshCartCount = async () => {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await window.fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (count) {
        count.textContent = String(cart.item_count);
        count.hidden = cart.item_count === 0;
      }
      cartLink?.setAttribute('aria-label', `Cart, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`);
    } catch (_) {
      // Keep the server-rendered count if the cart endpoint is temporarily unavailable.
    }
  };

  const lockBody = () => {
    lockedScrollY = window.scrollY;
    document.body.classList.add('ax-header-menu-open');
    document.body.style.top = `-${lockedScrollY}px`;
  };

  const unlockBody = () => {
    document.body.classList.remove('ax-header-menu-open');
    document.body.style.top = '';
    window.scrollTo(0, lockedScrollY);
  };

  const openMenu = () => {
    if (!drawer || header.classList.contains('is-open')) return;
    returnFocus = document.activeElement;
    drawer.hidden = false;
    drawer.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    header.classList.add('is-open');
    toggle?.setAttribute('aria-expanded', 'true');
    toggle?.setAttribute('aria-label', 'Close menu');
    lockBody();
    closeButton?.focus();
  };

  const closeMenu = (restoreFocus = true) => {
    if (!drawer || !header.classList.contains('is-open')) return;
    header.classList.remove('is-open');
    toggle?.setAttribute('aria-expanded', 'false');
    toggle?.setAttribute('aria-label', 'Open menu');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    unlockBody();
    window.setTimeout(() => {
      if (!header.classList.contains('is-open')) drawer.hidden = true;
    }, 360);
    if (restoreFocus) (returnFocus instanceof HTMLElement ? returnFocus : toggle)?.focus();
  };

  toggle?.addEventListener('click', () => header.classList.contains('is-open') ? closeMenu() : openMenu());
  closeButton?.addEventListener('click', () => closeMenu());
  drawer?.addEventListener('click', event => {
    if (event.target.closest('a')) closeMenu(false);
  });

  document.addEventListener('keydown', event => {
    if (!header.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeMenu();
      return;
    }
    if (event.key !== 'Tab' || !drawer) return;
    const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled]), summary')]
      .filter(element => element.getClientRects().length && !element.closest('[hidden]'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1024 && header.classList.contains('is-open')) closeMenu(false);
  }, { passive: true });

  window.addEventListener('scroll', () => {
    if (scrollFrame) return;
    scrollFrame = true;
    window.requestAnimationFrame(() => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 24);
      if (!header.classList.contains('is-open')) {
        if (y > 120 && y > previousY + 3) header.classList.add('is-hidden');
        else if (y < previousY - 3 || y < 80) header.classList.remove('is-hidden');
      } else header.classList.remove('is-hidden');
      previousY = y;
      scrollFrame = false;
    });
  }, { passive: true });

  document.addEventListener('cart:updated', refreshCartCount);
  document.addEventListener('cart:refresh', refreshCartCount);
  document.addEventListener('cart:add', refreshCartCount);
  document.addEventListener('cart:add:success', refreshCartCount);
  document.addEventListener('product:added', refreshCartCount);

  // Catch Shopify cart AJAX calls so the badge stays current for forms and quick-add buttons.
  if (!window.__axHeaderFetchWrapped) {
    window.__axHeaderFetchWrapped = true;
    const nativeFetch = window.fetch.bind(window);
    window.fetch = (...args) => {
      const input = args[0] instanceof Request ? args[0].url : String(args[0]);
      const isCartMutation = /\/cart\/(?:add|change|update|clear)\.js(?:[?#]|$)/.test(input);
      const result = nativeFetch(...args);
      if (isCartMutation) result.then(response => { if (response.ok) window.setTimeout(refreshCartCount, 0); }).catch(() => {});
      return result;
    };
  }

  refreshCartCount();
})();
